import { render } from "./NewGroupStudent.vue?vue&type=template&id=7237af3d&scoped=true"
import script from "./NewGroupStudent.vue?vue&type=script&lang=js"
export * from "./NewGroupStudent.vue?vue&type=script&lang=js"

import "./NewGroupStudent.vue?vue&type=style&index=0&id=7237af3d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7237af3d"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QToggle,QList,QExpansionItem});
